export const EVAL_PERMISSIONS_START = 'EVAL_PERMISSIONS_START';
export const EVAL_PERMISSIONS_COMPLETE = 'EVAL_PERMISSIONS_COMPLETE';
export const EVAL_PERMISSIONS_ERROR = 'EVAL_PERMISSIONS_ERROR';
